// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import "controllers";

// Import stylesheets
import "../stylesheets/application";

require("@rails/ujs").start();
import "@hotwired/turbo-rails";
require("@rails/activestorage").start();
require("channels");
require("jquery");
require("bootstrap");
require("application/social");
require("application/slider");
require("application/input-group-focus");
require("application/modal-auto-display");

const feather = require("feather-icons");
document.addEventListener("turbo:load", () => {
  feather.replace();
});

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
const images = require.context("../images", true, /\.(gif|jpg|png|svg|mp4|webm|ogv)$/i);
const imagePath = (name) => images(name, true);
